/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/camelcase */
import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import Permission from 'components/ValidPermission';
import Button from 'components/Button';
import Loading from 'components/Loading';
import i18n from 'i18n';
import _ from 'lodash';
import {
  editMaintenanceEnvironmentsRequest,
  getMaintenanceRequest,
} from 'modules/environments/actions';
import {
  EnvironmentFields,
  EnvironmentMaintenanceBlockInstancesProps,
  EnvironmentMaintenanceDisplayWarningProps,
  EnvironmentMaintenanceRemoveSessionProps,
} from 'modules/environments/interfaces';

import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import ApplicationState from 'store/interfaces';
import {
  CompanyData,
  PermissionsData,
  RolesEnum,
} from 'modules/authenticate/interfaces';
import { isClientOperator } from 'utils/role';
import { formatDateWithMoment, removeHTMLTags } from 'utils/helpers';
import {
  getEnvironmentMaintenanceHistoryRequest,
  getEnvironmentMaintenanceRequest,
  setEnvironmentMaintenanceRequest,
} from 'modules/maintenance/actions';
import {
  EnvironmentMaintenanceFields,
  EnvironmentMaintenanceHistoryResponse,
} from 'modules/maintenance/interfaces';
import { ModalFields } from 'modules/modal/interfaces';
import { modalClose, modalOpen } from 'modules/modal/actions';
import RestoreIcon from '@material-ui/icons/Restore';
import { Form, Formik } from 'formik';
import DynamicTextField from 'components/DynamicTextField';
import TitleDivider from 'components/TitleDivider';
import EnvironmentsTemplate from '../Templates/Environments';
import DisplayForm, {
  displayInitialValues,
  MaintenanceDisplay,
} from './DisplayForm/DisplayForm';
import ImmediateForm, {
  immediateInitialValues,
  MaintenanceImmediate,
} from './Immediate/ImmediateForm';
import ScheduleForm, {
  MaintenanceSchedule,
  scheduleInitialValues,
} from './Schedule/ScheduleForm';
import styles, { overrideModal } from './styles';
import RemoveSessionsForm, {
  RemoveSessionsFormDisplay,
  removeSessionsInitialValues,
} from './RemoveSessions/RemoveSessionsForm';
import screenFields from './screenFields';
import schema from './schema';
import MaintenanceHistoryEnvironment from './MaintenanceHistoryEnvironment';
import BlockInstancesForm, {
  BlockInstancesFormDisplay,
  blockInstancesInitialValues,
} from './BlockInstances/BlockInstancesForm';

const useStyles = makeStyles(styles);

interface ValuesProps {
  display: MaintenanceDisplay;
  schedule: MaintenanceSchedule;
  immediate: MaintenanceImmediate;
  remove: RemoveSessionsFormDisplay;
  blockInstances: BlockInstancesFormDisplay;
}

const initialValues: ValuesProps = {
  display: displayInitialValues,
  schedule: scheduleInitialValues,
  immediate: immediateInitialValues,
  remove: removeSessionsInitialValues,
  blockInstances: blockInstancesInitialValues,
};

interface Props {
  environmentSelected: EnvironmentFields | null;
  isLoadingMaintenance: boolean;
  environmentMaintenance: EnvironmentMaintenanceFields;
  isLoadingEnvironmentMaintenance: boolean;
  environmentMaintenanceDisplayWarning: EnvironmentMaintenanceDisplayWarningProps;
  environmentMaintenanceRemoveSession: EnvironmentMaintenanceRemoveSessionProps;
  environmentMaintenanceBlockInstances: EnvironmentMaintenanceBlockInstancesProps;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  environmentMaintenanceHistory: EnvironmentMaintenanceHistoryResponse;
  isLoading: boolean;
  permissions: PermissionsData | undefined;
  editMaintenanceEnvironmentsRequest: ({
    id,
    displayValues,
    removeSessionValues,
    blockInstancesValues,
    changedItems,
    hasBlockInstancesPermission,
    hasDisplayWarningPermission,
    hasRemoveSessionPermission,
  }) => Promise<void>;
  getMaintenanceRequest: ({
    id,
    hasBlockInstancesPermission,
    hasDisplayWarningPermission,
    hasRemoveSessionPermission,
  }) => Promise<void>;
  getEnvironmentMaintenanceRequest: ({ id }) => Promise<void>;
  setEnvironmentMaintenanceRequest: (props) => Promise<void>;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  getEnvironmentMaintenanceHistoryRequest: (props) => void;
}

const MaintenanceEnvironments = ({
  environmentMaintenance,
  isLoadingEnvironmentMaintenance,
  environmentSelected,
  environmentMaintenanceDisplayWarning,
  environmentMaintenanceRemoveSession,
  environmentMaintenanceBlockInstances,
  isLoadingMaintenance,
  role,
  companySelected,
  environmentMaintenanceHistory,
  isLoading,
  permissions,
  getMaintenanceRequest,
  getEnvironmentMaintenanceRequest,
  editMaintenanceEnvironmentsRequest,
  setEnvironmentMaintenanceRequest,
  modalOpen,
  modalClose,
  getEnvironmentMaintenanceHistoryRequest,
}: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const isMicro = environmentSelected?.behavior?.type === 'micro';

  const [values, setValues] = React.useState<ValuesProps>(initialValues);
  const [hasDisplayError, setHasDisplayError] = React.useState<boolean>(false);
  const [hasBlockInstanceError, setHasBlockInstanceError] = React.useState<
    boolean
  >(false);
  const [hasRemoveSessionsError, setHasRemoveSessionsError] = React.useState<
    boolean
  >(false);
  const [hasMaintenanceError, setHasMaintenanceError] = React.useState<boolean>(
    false
  );

  React.useEffect(() => {
    setValues({
      display: environmentMaintenanceDisplayWarning,
      schedule: environmentMaintenance.future_maintenance,
      immediate: environmentMaintenance.current_maintenance,
      remove: environmentMaintenanceRemoveSession,
      blockInstances: environmentMaintenanceBlockInstances,
    });
  }, [
    environmentMaintenanceDisplayWarning,
    environmentMaintenance,
    environmentMaintenanceRemoveSession,
    environmentMaintenanceBlockInstances,
    id,
  ]);
  const hasBlockInstancesPermission =
    !!permissions && permissions?.list_env_auto_block_instances_details;
  const hasDisplayWarningPermission =
    !!permissions && permissions?.can_list_env_scheduled_warnings_details;
  const hasRemoveSessionPermission =
    !!permissions && permissions?.list_env_auto_remove_user_session_details;
  const hasMaintenanceHistoryPermission =
    !!permissions && permissions?.environment_maintenance_history;

  React.useEffect(() => {
    getEnvironmentMaintenanceRequest({ id });
  }, [getEnvironmentMaintenanceRequest, id]);

  React.useEffect(() => {
    getMaintenanceRequest({
      id,
      hasBlockInstancesPermission,
      hasDisplayWarningPermission,
      hasRemoveSessionPermission,
    });
  }, [getMaintenanceRequest, id]);

  React.useEffect(() => {
    if (hasMaintenanceHistoryPermission) {
      getEnvironmentMaintenanceHistoryRequest({ id, query: { limit: 500 } });
    }
  }, [getEnvironmentMaintenanceHistoryRequest, id, environmentSelected]);

  const handleSetMaintenance = maintenanceValues => {
    const maintenanceDetails = [
      { labelKey: 'STATUS_KEY', value: i18n.t('ACTIVE_KEY') },
      {
        labelKey: 'START_ALERT_KEY',
        value: formatDateWithMoment(
          maintenanceValues?.schedule?.start_datetime
        ),
      },
      {
        labelKey: 'END_ALERT_KEY',
        value: formatDateWithMoment(maintenanceValues?.schedule?.end_datetime),
      },
      {
        labelKey: 'TERMINATE_SESSIONS_KEY',
        value: i18n.t(
          maintenanceValues?.schedule?.terminate_sessions
            ? 'ACTIVE_KEY'
            : 'INACTIVE_KEY'
        ),
      },
      {
        labelKey: 'TERMINATE_INSTANCES_KEY',
        value: i18n.t(
          maintenanceValues?.schedule?.terminate_instances
            ? 'ACTIVE_KEY'
            : 'INACTIVE_KEY'
        ),
      },
      {
        labelKey: 'MESSAGE_KEY',
        value: removeHTMLTags(String(maintenanceValues?.schedule?.message)),
      },
    ];
    const maintenanceImmediateDetails = [
      { labelKey: 'STATUS_KEY', value: i18n.t('ACTIVE_KEY') },
      {
        labelKey: 'MESSAGE_KEY',
        value: removeHTMLTags(String(maintenanceValues?.immediate?.message)),
      },
    ];
    modalOpen({
      title: i18n.t('MAINTENANCE_CONFIG_KEY'),
      content: (
        <>
          <Grid container>
            <Typography className={classes.maintenanceTitle}>{`${i18n.t(
              'MAINTENANCE_SCHEDULED_KEY'
            )}: `}</Typography>
            <Grid container>
              {maintenanceValues?.schedule?.enabled ? (
                <Grid
                  item
                  xs={12}
                  className={classes.maintenanceDetailsBoxActive}
                >
                  {maintenanceDetails.map((detail, index) => (
                    <Typography
                      key={index}
                      className={classes.maintenanceDetailsText}
                      component="div"
                    >
                      <Box fontWeight="bold" display="inline">
                        {`${i18n.t(detail?.labelKey)}: `}
                      </Box>
                      {detail?.value}
                    </Typography>
                  ))}
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  className={classes.maintenanceDetailsBoxInactive}
                >
                  <Typography
                    className={classes.maintenanceDetailsText}
                    component="div"
                  >
                    <Box fontWeight="bold" display="inline">
                      {`${i18n.t('STATUS_KEY')}: `}
                    </Box>
                    {i18n.t('INACTIVE_KEY')}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid container>
            <Typography className={classes.maintenanceTitle}>{`${i18n.t(
              'MAINTENANCE_MANUAL_KEY'
            )}: `}</Typography>
            <Grid container>
              {maintenanceValues?.immediate?.enabled ? (
                <Grid
                  item
                  xs={12}
                  className={classes.maintenanceDetailsBoxActive}
                >
                  {maintenanceImmediateDetails.map((detail, index) => (
                    <Typography
                      key={index}
                      className={classes.maintenanceDetailsText}
                      component="div"
                    >
                      <Box fontWeight="bold" display="inline">
                        {`${i18n.t(detail?.labelKey)}: `}
                      </Box>
                      {detail?.value}
                    </Typography>
                  ))}
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  className={classes.maintenanceDetailsBoxInactive}
                >
                  <Typography
                    className={classes.maintenanceDetailsText}
                    component="div"
                  >
                    <Box fontWeight="bold" display="inline">
                      {`${i18n.t('STATUS_KEY')}: `}
                    </Box>
                    {i18n.t('INACTIVE_KEY')}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          <TitleDivider overrideClasses={{ title: { marginTop: 8 } }}>
            {`${i18n.t('CONFIRM_MAINTENANCE_CONFIG_KEY')}:`}
          </TitleDivider>
          <Formik
            initialValues={{ reason: '' }}
            enableReinitialize
            validationSchema={schema}
            validateOnChange
            validateOnBlur
            onSubmit={() => modalClose()}
          >
            {({ setFieldValue, errors, values, isValid }) => {
              return (
                <React.Fragment>
                  <Form>
                    <Grid container>
                      <Grid container spacing={2} className={classes.fields}>
                        <DynamicTextField
                          {...screenFields[0]}
                          setFieldValue={setFieldValue}
                          value={values?.reason}
                          errors={errors}
                        />
                      </Grid>

                      <Grid
                        container
                        justify="flex-end"
                        className={classes.deleteButtons}
                      >
                        <Button
                          submitButton
                          id="confirm-button"
                          onClick={() => {
                            setEnvironmentMaintenanceRequest({
                              id,
                              values: {
                                current_maintenance:
                                  maintenanceValues?.immediate,
                                future_maintenance: maintenanceValues?.schedule,
                                reason: values?.reason,
                              },
                            });
                            modalClose();
                          }}
                          disabled={!values.reason || !isValid}
                          isLoading={isLoadingEnvironmentMaintenance}
                        >
                          {i18n.t('CONFIRM_KEY')}
                        </Button>
                        <Button
                          id="cancel-button"
                          variant="outlined"
                          onClick={modalClose}
                        >
                          {i18n.t('CANCEL_KEY')}
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                </React.Fragment>
              );
            }}
          </Formik>
        </>
      ),
    });
  };

  const handleSubmit = () => {
    const startValues = {
      display: environmentMaintenanceDisplayWarning,
      schedule: environmentMaintenance?.future_maintenance,
      immediate: environmentMaintenance?.current_maintenance,
      remove: environmentMaintenanceRemoveSession,
      blockInstances: environmentMaintenanceBlockInstances,
    };

    const changedItems: string[] = [];
    let scheduleChanged = false;
    let immediateChanged = false;

    const deepEqual = (first: any, second: any): boolean => {
      if (
        (first === '' && second === '<p><br></p>') ||
        (first === '<p><br></p>' && second === '')
      ) {
        return true;
      }
      if (first === second) return true;

      if (
        typeof first !== 'object' ||
        typeof second !== 'object' ||
        !first ||
        !second
      ) {
        return false;
      }

      const firstKeys = Object.keys(first);
      const secondKeys = Object.keys(second);

      if (firstKeys.length !== secondKeys.length) return false;

      return firstKeys.every(key =>
        secondKeys.includes(key) ? deepEqual(first[key], second[key]) : false
      );
    };

    const checkChanges = (key: 'schedule' | 'immediate') => {
      const startValue = startValues[key];
      const currentValue = values[key];

      if (
        (startValue === null && currentValue === null) ||
        (startValue === undefined && currentValue === undefined)
      ) {
        return;
      }

      if (!deepEqual(startValue, currentValue)) {
        if (key === 'schedule') scheduleChanged = true;
        if (key === 'immediate') immediateChanged = true;
        changedItems.push(key);
      }
    };

    (['schedule', 'immediate'] as const).forEach(checkChanges);

    if (values) {
      if (
        !deepEqual(startValues.display, values.display) ||
        !deepEqual(startValues.remove, values.remove) ||
        !deepEqual(startValues.blockInstances, values.blockInstances)
      ) {
        const changedItems = [] as string[];

        if (!deepEqual(startValues.display, values.display)) {
          changedItems.push('display');
        }

        if (!deepEqual(startValues.remove, values.remove)) {
          changedItems.push('remove');
        }
        if (!deepEqual(startValues.blockInstances, values.blockInstances)) {
          changedItems.push('blockInstances');
        }

        editMaintenanceEnvironmentsRequest({
          id,
          displayValues: values.display,
          removeSessionValues: values.remove,
          blockInstancesValues: values.blockInstances,
          changedItems,
          hasBlockInstancesPermission,
          hasDisplayWarningPermission,
          hasRemoveSessionPermission,
        });
      }
    }

    if (scheduleChanged || immediateChanged) {
      handleSetMaintenance(values);
    }
  };

  const disabledButton =
    hasDisplayError ||
    hasMaintenanceError ||
    hasBlockInstanceError ||
    hasRemoveSessionsError;

  const handleOpenMaintenance = () => {
    modalOpen({
      title: i18n.t('DETAILS_MAINTENANCE_HISTORY_KEY'),
      content: (
        <MaintenanceHistoryEnvironment
          currentRequest={
            environmentMaintenanceHistory?.results?.[0]?.request_uuid
          }
          currentRequestDate={String(
            environmentMaintenanceHistory?.results?.[0]?.updated_at
          )}
        />
      ),
      overrideClasses: overrideModal,
      maxWidth: 'md',
      footer: (
        <Grid>
          <Button id="close-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CLOSE_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  return (
    <EnvironmentsTemplate
      currentPage="maintenance"
      titlePage={environmentSelected?.name}
      breadcrumbs={[
        {
          name: i18n.t('ENVIRONMENTS_KEY'),
          link: '/environments',
        },
        {
          name: i18n.t('MAINTENANCE_KEY'),
        },
      ]}
      titleContent={i18n.t('ENVIRONMENTS_PAGE.MAINTENANCE_TITLE_KEY')}
      subtitleContent={i18n.t('ENVIRONMENTS_PAGE.MAINTENANCE_SUBTITLE_KEY')}
      actionsContent={
        <>
          <Permission value="environment_maintenance_history">
            <Button
              onClick={handleOpenMaintenance}
              className={classes.maintenanceHistoryButton}
              endIcon={<RestoreIcon />}
              disabled={
                isLoadingMaintenance ||
                isLoadingEnvironmentMaintenance ||
                isLoading
              }
            >
              {i18n.t('MAINTENANCE_HISTORY_KEY')}
            </Button>
          </Permission>
        </>
      }
    >
      {isLoadingEnvironmentMaintenance || isLoadingMaintenance || isLoading ? (
        <Loading />
      ) : (
        <>
          <Grid container className={classes.cardsContent}>
            <Permission value="can_list_env_scheduled_warnings_details">
              <Grid item className={classes.maintenanceManual} xs={12} md={6}>
                <DisplayForm
                  permissions={permissions}
                  role={role}
                  companySelected={companySelected}
                  defaultValue={values.display}
                  onChange={(display: MaintenanceDisplay) => {
                    setValues({ ...values, display });
                  }}
                  setHasError={setHasDisplayError}
                />
              </Grid>
            </Permission>
            <Permission value="edit_environment_maintenance">
              <Grid item className={classes.maintenanceManual} xs={12} md={6}>
                <ScheduleForm
                  role={role}
                  companySelected={companySelected}
                  defaultValue={values?.schedule}
                  setHasError={setHasMaintenanceError}
                  onChange={(schedule: MaintenanceSchedule) => {
                    setValues({
                      ...values,
                      schedule,
                      immediate: {
                        ...values?.immediate,
                        enabled: false,
                      },
                    });
                  }}
                />
              </Grid>
            </Permission>
            <Permission value="get_environment_maintenance">
              <Grid item className={classes.maintenanceManual} xs={12} md={6}>
                <ImmediateForm
                  role={role}
                  companySelected={companySelected}
                  defaultValue={values?.immediate}
                  onChange={_.debounce((immediate: MaintenanceImmediate) => {
                    setValues({
                      ...values,
                      immediate,
                      schedule: {
                        ...values?.schedule,
                        enabled: false,
                      },
                    });
                  }, 300)}
                />
              </Grid>
            </Permission>
            {!isClientOperator(role) && (
              <Permission value="list_env_auto_remove_user_session_details">
                <Grid item className={classes.maintenanceManual} xs={12} md={6}>
                  <RemoveSessionsForm
                    permissions={permissions}
                    setHasError={setHasRemoveSessionsError}
                    role={role}
                    companySelected={companySelected}
                    defaultValue={values.remove}
                    onChange={_.debounce(
                      (remove: RemoveSessionsFormDisplay) => {
                        setValues({ ...values, remove });
                      },
                      300
                    )}
                  />
                </Grid>
              </Permission>
            )}
            {!isMicro && (
              <Permission value="list_env_auto_block_instances_details">
                <Grid item className={classes.maintenanceManual} xs={12} md={6}>
                  <BlockInstancesForm
                    permissions={permissions}
                    role={role}
                    setHasError={setHasBlockInstanceError}
                    companySelected={companySelected}
                    defaultValue={values.blockInstances}
                    onChange={(blockInstances: BlockInstancesFormDisplay) => {
                      setValues({ ...values, blockInstances });
                    }}
                  />
                </Grid>
              </Permission>
            )}
          </Grid>
          <Grid container justify="flex-end" className={classes.buttons}>
            <Button
              id="save-button"
              onClick={handleSubmit}
              isLoading={
                isLoadingEnvironmentMaintenance || isLoadingMaintenance
              }
              submitButton
              disabled={disabledButton}
            >
              {i18n.t('SAVE_KEY')}
            </Button>
            <Button
              id="cancel-button"
              variant="outlined"
              onClick={() => history.push('/environments')}
            >
              {i18n.t('CANCEL_KEY')}
            </Button>
          </Grid>
        </>
      )}
    </EnvironmentsTemplate>
  );
};

const mapStateToProps = ({
  environments: {
    environmentMaintenanceDisplayWarning,
    environmentMaintenanceRemoveSession,
    environmentMaintenanceBlockInstances,
    environmentSelected,
    isLoadingMaintenance,
    isLoading,
  },
  authenticate: { companySelected, data },
  maintenance: {
    isLoadingEnvironmentMaintenance,
    environmentMaintenance,
    environmentMaintenanceHistory,
  },
}: ApplicationState) => ({
  environmentMaintenanceDisplayWarning,
  environmentMaintenanceRemoveSession,
  environmentMaintenanceBlockInstances,
  environmentSelected,
  companySelected,
  role: data?.role,
  isLoadingMaintenance,
  isLoadingEnvironmentMaintenance,
  environmentMaintenance,
  environmentMaintenanceHistory,
  isLoading,
  authenticate: { data },
  permissions: data?.permissions,
});

export default connect(mapStateToProps, {
  editMaintenanceEnvironmentsRequest,
  getMaintenanceRequest,
  getEnvironmentMaintenanceRequest,
  setEnvironmentMaintenanceRequest,
  modalOpen,
  modalClose,
  getEnvironmentMaintenanceHistoryRequest,
})(MaintenanceEnvironments);
